module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "feedback-knowledge-js": "static-1.4899",
      "hs-test-utils": "static-1.7421",
      "I18n": "static-7.1466",
      "jasmine-runner": "static-1.5844",
      "quartz": "static-1.6244",
      "hubspot-url-utils": "static-1.3645",
      "outpost": "static-1.3723",
      "PatternValidationJS": "static-1.437",
      "react": "static-7.151",
      "moment": "static-3.26",
      "foundations-components": "static-1.6963",
      "framer-motion": "static-1.57",
      "hs-test-utils-bend-plugin": "static-1.2532",
      "msw": "static-1.39",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.139",
      "enviro": "static-4.349",
      "i18n-data": "static-1.211",
      "metrics-js": "static-1.9161",
      "moment-timezone": "static-5.72",
      "react-utils": "static-2.4808",
      "jasmine": "static-4.3725",
      "PortalIdParser": "static-2.322",
      "quartz-core-utils": "static-1.3111",
      "StyleGuideUI": "static-3.478",
      "quartz-core": "static-1.5463",
      "csstype": "static-1.50",
      "bend-plugin-foundations-components": "static-1.3232",
      "floating-ui": "static-1.45",
      "foundations-assets": "static-1.4291",
      "foundations-theming": "static-1.3769",
      "foundations-theming-specialty": "static-1.1485",
      "hs-story-utils": "static-1.8801",
      "react-aria": "static-1.44",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.86",
      "styled-components": "static-2.64",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.335",
      "ui-images": "static-2.979",
      "bender-build-tools": "static-1.2592",
      "hoist-non-react-statics": "static-3.9",
      "dispatcher": "static-1.125",
      "general-store": "static-6.20",
      "HeadJS": "static-2.633",
      "history": "static-4.47",
      "hs-promise-rejection-tracking": "static-1.4951",
      "hub-http": "static-1.5499",
      "hub-http-janus": "static-1.710",
      "hub-http-shared-msw-handlers": "static-1.8674",
      "hubspotter-http": "static-1.4061",
      "hubspotter-http-shared-msw-handlers": "static-1.8672",
      "icons": "static-2.599",
      "mobile-manifest-mixins": "static-1.406",
      "platform-navigation-bootstrap": "static-1.11988",
      "quick-fetch": "static-1.3460",
      "raven": "static-3.5432",
      "raven-hubspot": "static-1.5739",
      "react-rhumb": "static-1.16064",
      "react-router-dom": "static-5.26",
      "UIComponents": "static-3.7889",
      "webpack-env": "static-1.54",
      "bend-plugin-foundations-theming": "static-1.2252",
      "foundations-theming-base": "static-1.2754",
      "react-input-autosize": "static-2.17",
      "classnames": "static-2.10",
      "ts-schema": "static-1.3594",
      "sassPrefix": "static-1.145",
      "platform-infra-nav-components": "static-1.7183",
      "cssUtils": "static-1.617",
      "head-dlb": "static-1.4465",
      "HubStyle": "static-2.11250",
      "HubStyleTokens": "static-2.10942",
      "hs-lodash": "static-4.45"
    },
    "depPathPrefixes": {
      "feedback-knowledge-js": "/feedback-knowledge-js/static-1.4899",
      "hs-test-utils": "/hs-test-utils/static-1.7421",
      "I18n": "/I18n/static-7.1466",
      "jasmine-runner": "/jasmine-runner/static-1.5844",
      "quartz": "/quartz/static-1.6244",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3645",
      "outpost": "/outpost/static-1.3723",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react": "/react/static-7.151",
      "moment": "/moment/static-3.26",
      "foundations-components": "/foundations-components/static-1.6963",
      "framer-motion": "/framer-motion/static-1.57",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2532",
      "msw": "/msw/static-1.39",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.139",
      "enviro": "/enviro/static-4.349",
      "i18n-data": "/i18n-data/static-1.211",
      "metrics-js": "/metrics-js/static-1.9161",
      "moment-timezone": "/moment-timezone/static-5.72",
      "react-utils": "/react-utils/static-2.4808",
      "jasmine": "/jasmine/static-4.3725",
      "PortalIdParser": "/PortalIdParser/static-2.322",
      "quartz-core-utils": "/quartz-core-utils/static-1.3111",
      "StyleGuideUI": "/StyleGuideUI/static-3.478",
      "quartz-core": "/quartz-core/static-1.5463",
      "csstype": "/csstype/static-1.50",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3232",
      "floating-ui": "/floating-ui/static-1.45",
      "foundations-assets": "/foundations-assets/static-1.4291",
      "foundations-theming": "/foundations-theming/static-1.3769",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1485",
      "hs-story-utils": "/hs-story-utils/static-1.8801",
      "react-aria": "/react-aria/static-1.44",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.86",
      "styled-components": "/styled-components/static-2.64",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.335",
      "ui-images": "/ui-images/static-2.979",
      "bender-build-tools": "/bender-build-tools/static-1.2592",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "dispatcher": "/dispatcher/static-1.125",
      "general-store": "/general-store/static-6.20",
      "HeadJS": "/HeadJS/static-2.633",
      "history": "/history/static-4.47",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4951",
      "hub-http": "/hub-http/static-1.5499",
      "hub-http-janus": "/hub-http-janus/static-1.710",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8674",
      "hubspotter-http": "/hubspotter-http/static-1.4061",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8672",
      "icons": "/icons/static-2.599",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.406",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11988",
      "quick-fetch": "/quick-fetch/static-1.3460",
      "raven": "/raven/static-3.5432",
      "raven-hubspot": "/raven-hubspot/static-1.5739",
      "react-rhumb": "/react-rhumb/static-1.16064",
      "react-router-dom": "/react-router-dom/static-5.26",
      "UIComponents": "/UIComponents/static-3.7889",
      "webpack-env": "/webpack-env/static-1.54",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2252",
      "foundations-theming-base": "/foundations-theming-base/static-1.2754",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "classnames": "/classnames/static-2.10",
      "ts-schema": "/ts-schema/static-1.3594",
      "sassPrefix": "/sassPrefix/static-1.145",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7183",
      "cssUtils": "/cssUtils/static-1.617",
      "head-dlb": "/head-dlb/static-1.4465",
      "HubStyle": "/HubStyle/static-2.11250",
      "HubStyleTokens": "/HubStyleTokens/static-2.10942",
      "hs-lodash": "/hs-lodash/static-4.45"
    },
    "project": "feedback-knowledge-js",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};